import React, { useState } from 'react';
import PropTypes from 'prop-types';

function CollapsibleSection({
 title, headerClassName = '', headerContent = null, children,
}) {
  const [expanded, setExpanded] = useState(false);

  const toggle = () => setExpanded((prev) => !prev);

  return (
    <div className="border-top">
      <div
        role="button"
        tabIndex={0}
        aria-expanded={expanded}
        onClick={toggle}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle();
          }
        }}
        className={`p-3 fw-bold paragraph-sm d-flex align-items-center ${headerClassName}`}
        style={{ cursor: 'pointer' }}
      >
        <i className={`fa-solid fa-fw fa-chevron-${expanded ? 'down' : 'right'} me-2`} />
        {title}
        {headerContent}
      </div>

      {expanded && children}
    </div>
  );
}

CollapsibleSection.propTypes = {
  title: PropTypes.string.isRequired,
  headerClassName: PropTypes.string,
  headerContent: PropTypes.node,
  children: PropTypes.node.isRequired,
};

export default CollapsibleSection;
